import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { Box, Container, Hide, Section, Video } from '@miro-site/core';
import { LazyImageAdapter, Content, Headline, ButtonAdapter } from '@miro-site/components_utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
gsap.registerPlugin(ScrollTrigger);
var Row = styled(Box).attrs({
  $styles: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between'
  },
  $mx: [null, -10]
}).withConfig({
  displayName: "HeroWithAnimationImage__Row",
  componentId: "sc-4kfo9a-0"
})([""]);
var Col = styled(Box).attrs({
  $styles: {
    flex: ['0 0 100%', '0 0 auto']
  },
  $px: [null, 10]
}).withConfig({
  displayName: "HeroWithAnimationImage__Col",
  componentId: "sc-4kfo9a-1"
})([""]);
var ButtonContainer = styled(Box).attrs({
  $mt: [24, 32]
}).withConfig({
  displayName: "HeroWithAnimationImage__ButtonContainer",
  componentId: "sc-4kfo9a-2"
})([""]);
var Media = styled(Box).attrs({
  $styles: {
    paddingTop: ['73.26%', null],
    marginTop: [40, null],
    position: ['relative', undefined]
  },
  $mt: 48
}).withConfig({
  displayName: "HeroWithAnimationImage__Media",
  componentId: "sc-4kfo9a-3"
})([""]);
var ShapeContainer = styled(Box).attrs({
  $styles: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  }
}).withConfig({
  displayName: "HeroWithAnimationImage__ShapeContainer",
  componentId: "sc-4kfo9a-4"
})([""]);
var ImageContainer = styled(Box).attrs({
  $styles: {
    position: 'absolute',
    top: '50%',
    left: 20,
    right: 20,
    transform: 'translateY(-50%)',
    zIndex: 2
  }
}).withConfig({
  displayName: "HeroWithAnimationImage__ImageContainer",
  componentId: "sc-4kfo9a-5"
})([""]);
var VideoContainer = styled(Box).attrs({
  $pt: 96,
  $mt: -48
}).withConfig({
  displayName: "HeroWithAnimationImage__VideoContainer",
  componentId: "sc-4kfo9a-6"
})([""]);
var VideoSection = styled(Box).attrs({
  $styles: {
    overflow: 'hidden',
    paddingTop: '52.67%',
    position: 'relative'
  }
}).withConfig({
  displayName: "HeroWithAnimationImage__VideoSection",
  componentId: "sc-4kfo9a-7"
})([""]);
var VideoWrapper = styled(Box).attrs({
  $styles: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  }
}).withConfig({
  displayName: "HeroWithAnimationImage__VideoWrapper",
  componentId: "sc-4kfo9a-8"
})([""]);

var HeroWithAnimationImage = function HeroWithAnimationImage(props) {
  var headline = props.headline,
      button = props.button,
      content = props.content,
      shape = props.shape,
      image = props.image,
      video = props.video;
  var videoContainerRef = useRef(null);

  var _useState = useState(false),
      videoPlay = _useState[0],
      setVideoPlay = _useState[1];

  useEffect(function () {
    var videoContainer = videoContainerRef.current;
    var scrollTrigger = ScrollTrigger.create({
      trigger: videoContainer,
      start: 'center center',
      once: true,
      onEnter: function onEnter() {
        setVideoPlay(true);
      }
    });
    return function () {
      scrollTrigger.kill();
    };
  }, []);
  return /*#__PURE__*/_jsxs(Section, {
    "data-place": "Hero Section",
    $styles: {
      position: 'relative',
      overflow: 'hidden'
    },
    $noPaddingTop: true,
    children: [/*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsxs(Col, {
          children: [headline && /*#__PURE__*/_jsx(Headline, _objectSpread({
            size: "medium",
            tag: "h1",
            headingProps: {
              $styles: {
                maxWidth: [null, 630]
              }
            }
          }, headline)), button && /*#__PURE__*/_jsx(ButtonContainer, {
            children: /*#__PURE__*/_jsx(ButtonAdapter, _objectSpread({
              arrow: true,
              type: "blue"
            }, button))
          })]
        }), /*#__PURE__*/_jsx(Col, {
          children: content && /*#__PURE__*/_jsx(Content, _objectSpread({
            size: "large",
            color: "grey",
            textProps: {
              $styles: {
                maxWidth: [null, 455],
                marginTop: [64, null]
              }
            }
          }, content))
        })]
      }), /*#__PURE__*/_jsx(Hide, {
        $on: ['small'],
        children: video && /*#__PURE__*/_jsx(VideoContainer, {
          ref: videoContainerRef,
          children: /*#__PURE__*/_jsx(VideoSection, {
            children: /*#__PURE__*/_jsx(VideoWrapper, {
              children: /*#__PURE__*/_jsx(Video, _objectSpread(_objectSpread({}, video), {}, {
                togglePlay: videoPlay
              }))
            })
          })
        })
      })]
    }), /*#__PURE__*/_jsx(Hide, {
      $on: ['medium', 'mediumUp', 'mediumDown', 'large'],
      children: /*#__PURE__*/_jsxs(Media, {
        children: [shape && /*#__PURE__*/_jsx(ShapeContainer, {
          children: /*#__PURE__*/_jsx(LazyImageAdapter, {
            assets: shape
          })
        }), image && /*#__PURE__*/_jsx(ImageContainer, {
          children: /*#__PURE__*/_jsx(LazyImageAdapter, {
            assets: image
          })
        })]
      })
    })]
  });
};

export default HeroWithAnimationImage;